export const MAX_WALLETS = 3;
